import React from 'react';

type Props = {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>,
  children: null | React.ReactNode
}

export const Modal = (props: Props) => {
  const {setIsOpen, children} = props;

  return (
    <>
      <button className="modal-overlay" onClick={() => setIsOpen(false)}></button>
      <div className="modal-wrap modal-wrap--react">
        <button type="button" className="modal-close" onClick={(e) => {setIsOpen(false); e.stopPropagation();}}>
          close
        </button>
        <div className="modal-content panel-both">
          {children}
        </div>
      </div>
    </>
  );
};
